export default "__VITE_PUBLIC_ASSET__a0853f51__"